import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-center" }
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "Informações do colaborador", -1)
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = { class: "d-flex" }
const _hoisted_9 = { style: {"display":"flex","justify-content":"end"} }

import { ref, computed, watch, onMounted, withDefaults } from 'vue';
import { Authentication, } from '@/store';
import { Group, Company } from '@/core/model';
import {
    getHeadquartersByUser,
    getSubsidiariesByHeadquartersId,
} from '@/core/service/CompanyService';
import { MoleculeModal } from '@/components/molecules';
import {
    AddUserIcon,
    AtomButton,
    AtomInput,
    SearchIcon,
    AtomCheckBox,
    AtomSelect,
    AtomToogleButton
} from '@/components/atoms';
import { IOptionsSelect, IToggleButon } from '@/types';

import { getLanguage } from "@/utils/locale";
import { messages } from "@/utils/i18n";
interface IProps {
    showModal: boolean;
    group?: Group;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeRegisterGoalsModal',
  props: {
    showModal: { type: Boolean, default: false },
    group: {}
  },
  setup(__props: any) {

let locale:string = messages[getLanguage()]['message'];  

const orientation = ref<IToggleButon[]>([
    { text: locale['common']['brand'], value: "Marca" },
    { text: locale['goals_create']['resale'], value: "Revenda" },
    { text: locale['common']['warehouse'], value: "Deposito" },
])
const props = __props

const show = ref<boolean>(props.showModal);
watch(() => props.showModal,
    () => {
        show.value = props.showModal;
    })


return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createTextVNode(_toDisplayString(_ctx.showModal) + " ", 1),
    _createVNode(_unref(MoleculeModal), {
      width: "1192px",
      onHasBtnClose: ($event: any) => (false),
      onHasBtnConfirm: ($event: any) => (false),
      onHandleCancel: _cache[0] || (_cache[0] = ($event: any) => (show.value = false)),
      title: "Realizar cadastro de Metas",
      subtitle: 'Preencha todos os campos corretamente para cadastrar uma nova meta',
      show: show.value
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AtomSelect), {
                    label: _ctx.$t('message.common.name'),
                    required: "",
                    placeholder: _ctx.$t('message.goals_details.details'),
                    msgError: _ctx.$t('message.common.required_field')
                  }, null, 8, ["label", "placeholder", "msgError"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AtomSelect), {
                    label: _ctx.$t('message.common.role'),
                    required: "",
                    placeholder: _ctx.$t('message.common.employee_role'),
                    msgError: _ctx.$t('message.common.required_field')
                  }, null, 8, ["label", "placeholder", "msgError"])
                ]),
                _: 1
              })
            ]),
            _createVNode(_unref(AtomSelect), {
              label: _ctx.$t('message.common.seller'),
              required: "",
              placeholder: _ctx.$t('message.common.sellerName'),
              msgError: _ctx.$t('message.common.required_field')
            }, null, 8, ["label", "placeholder", "msgError"]),
            _hoisted_5,
            _createVNode(_component_v_divider),
            _hoisted_6,
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('message.goals_create.goal_registration')), 1),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createElementVNode("label", null, _toDisplayString(_ctx.$t('message.common.goal_orientation')), 1),
                  _createVNode(_unref(AtomToogleButton), { buttons: orientation.value }, null, 8, ["buttons"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AtomInput), {
                    maxWidth: '100%',
                    label: _ctx.$t('message.common.performer'),
                    classes: "mb-5",
                    placeholder: "Número de performantes",
                    required: ""
                  }, null, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AtomSelect), {
                    label: _ctx.$t('message.common.triggers'),
                    required: "",
                    placeholder: _ctx.$t('message.triggers.trigger_name')
                  }, null, 8, ["label", "placeholder"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AtomSelect), {
                    label: _ctx.$t('message.common.seasonality'),
                    required: "",
                    placeholder: _ctx.$t('message.seasoning.name_seasonality')
                  }, null, 8, ["label", "placeholder"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_unref(AtomButton), null, {
                default: _withCtx(() => [
                  _createTextVNode("Adicionar")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})